module.exports = __webpack_public_path__ + "media/images/lb/645-888434b7e37451f18dbe8ada019f2b4d.svg";